var path = '/store/action_log/views/extended-list.tpl.html';
var html = "<div ng-controller=\"ActionLogExtendedListViewController as elvc\" ng-init=\"elvc.setRow(row); elvc.setStore(vm.store);\"\n     ng-click=\"$event.stopPropagation();\" class=\"abcbcbc\">\n    <ng-include ng-if=\"elvc.actionSpecialViews[elvc.row.action]\" src=\"elvc.actionSpecialViews[elvc.row.action]\"></ng-include>\n    <div ng-if=\"!elvc.actionSpecialViews[elvc.row.action]\" class=\"msg info-msg mb-20\">\n        No extended information available\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/store/action_log/views/extended-list.tpl.html
// module id = 2335
// module chunks = 1